export enum KeyboardState {
    KeyboardWillShow,
    KeyboardDidShow,
    KeyboardWillHide,
    KeyboardDidHide
}